import { render, staticRenderFns } from "./ServicesPage2.vue?vue&type=template&id=3d46c0cb&scoped=true&"
import script from "./ServicesPage2.vue?vue&type=script&lang=js&"
export * from "./ServicesPage2.vue?vue&type=script&lang=js&"
import style0 from "./ServicesPage2.vue?vue&type=style&index=0&id=3d46c0cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46c0cb",
  null
  
)

export default component.exports